import { useEffect } from 'react';

import { useDebounce } from '@/shared/hooks/useDebounce';
import { sanitizeToText } from '@/shared/lib/sanitize';

import { useSearchStore } from '@/entities/search';

export const useSearchInput = () => {
  const { query, searchValue } = useSearchStore();
  const debouncedValue = useDebounce(searchValue, 500);

  const handleChange = (value: string) => {
    const sanitizedValue = sanitizeToText(value);
    useSearchStore.getState().setSearchValue(sanitizedValue);
  };

  const handleClear = () => {
    useSearchStore.getState().setSearchValue('');
  };

  useEffect(() => {
    const sanitizedQuery = sanitizeToText(query);
    useSearchStore.getState().setSearchValue(sanitizedQuery);
  }, [query]);

  return {
    value: searchValue,
    setValue: (value: string) => useSearchStore.getState().setSearchValue(value),
    debouncedValue,
    handleChange,
    handleClear,
  };
};
